import styled from 'styled-components';

import { COLORS } from '@avalara/bat-apps-shared/constants';

export const DoubleColumnBanner = styled.div`
  display: flex;
  min-height: 385px;
  background-color: ${COLORS.lightBlue};
  width:100%;
  color: ${COLORS.white};

  .banner-container {
    padding-top: 65px;
    padding-bottom: 65px;
    width: 100%;
  }

  .banner-header-xs {
    font-size: 16px;
  }

  .banner-header-ks {
    font-size: 20px;
  }

  .banner-header-sm {
    font-size: 25px;
  }

  .banner-header-md {
    font-size: 30px;
  }

  .banner-header-lg {
    font-size: 32px;
  }

  .banner-header-xl {
    font-size: 38px;
  }

  .column-margin {
    margin-right: 45px;
  }

  button {
    font-size: 16px;
  }

  .header-second-col {
    background-color: ${COLORS.white};
    color: black;
    border-radius: 3px;

    hr, s-icon {
      color: ${COLORS.lightBlue};
    }

    s-col {
      padding: 0px;
      min-width: auto;
    }

    .includes-text {
      font-size: 16px;
      margin-top: 14px;
      margin-bottom: 5px;
    }

    .license-list {
      margin: 0 30px;
    }

    .checkmark-text {
      font-size: 18px;
      margin-bottom: 4px;
    }

    .checkmark {
      max-width: 20px;
      padding-top: 5px;
    }

    .white-panel-subtext {
      margin: 10px 32px;
    }
  }

  a.license-button.secondary {
    color: ${COLORS.grayBlack};
    background-color: #fff;
    padding: 20px;
    margin-bottom: 20px;
  }
`;
